import React from "react";

import {
    createComponentBase,
    BaseComponentProps,
} from "../../../../libs/components";
import { Dropdown } from "../../../atoms/dropdown";
import { useUserListQuery } from "../../../../store/user/userSlice";
import { DropdownOptionsType } from "../../../../types";
import { Icon } from "../../../atoms/icon";
import { useOktaUserListQuery } from "../../../../store/okta/userSlice";
import {
    useAssigningListOfUserQuery,
    useAssignListOfSaaSToolQuery,
    useMemberOfEntityQuery,
} from "../../../../store/requestManagement/requestSlice";
import { saasToolImageSrc } from "../../../../utils";
import { Modal } from "../../../molecules/modal";
import {
    All_SAAS_TOOLS,
    REQUEST_MANAGEMENT_SAAS_TOOLS,
} from "../../../../constants/constants";
import { Input } from "../../../atoms/input";

export interface PermissionManagementProps extends BaseComponentProps {
    payload: any;
    setPayload: (payload: any) => void;
    approverList: any;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PermissionManagementRequest = ({
    className,
    payload,
    setPayload,
    approverList,
    setLoading,
}: PermissionManagementProps) => {
    const componentClassName = "o-permissionManagementRequest";
    const { Container } = createComponentBase(componentClassName, "div");

    // const userData = useSelector((state: userStateType) => state.user.user);

    const { data: users, isLoading: usersLoading } = useOktaUserListQuery({});
    const { data: managerList, isLoading: managerLoading } = useUserListQuery({});

    const [saasToolOptions, setSaaSToolOptions] = React.useState<any>([]);
    const [roleOptionList, setRoleOptionList] = React.useState<any>([]);
    const [entityOptions, setEntityOptions] = React.useState<any>([]);
    const [isOpenEntityModal, setIsOpenEntityModal] = React.useState(false);
    const [isOpenSaaSToolModal, setIsOpenSaaSToolModal] = React.useState(false);
    const [assigned, setAssigned] = React.useState<any>({
        saasTool: "",
        assignedList: [],
    });
    const [assignedSaasToolUsers, setAssignedSaasToolUsers] = React.useState<any>(
        []
    );
    const [selectedSaaSTool, setSelectedSaaSTool] = React.useState<any>(null);
    const [saasToolItems, setSaasToolItems] = React.useState<any>([]);
    const [displayItem, setDisplayItem] = React.useState<any>("User");
    const [searchValue, setSearchValue] = React.useState<any>("");
    const [entityId, setEntityId] = React.useState<any>(null);
    const [entityMemberList, setEntityMemberList] = React.useState([]);

    const {
        data: assigningEntities,
        isLoading: assigningLoading,
        isFetching: assigningFetching,
        // isSuccess: assigningSuccess,
    } = useAssigningListOfUserQuery(payload?.user?.value?.value, {
        skip: !payload?.user?.value?.value,
    });

    const {
        data: saaSToolUsers,
        isLoading: getUsersBySaaSToolLoading,
        isSuccess: getUsersBySaaSToolSuccess,
        isFetching: UsersBySaaSToolRefetching,
    } = useAssignListOfSaaSToolQuery(selectedSaaSTool, {
        skip: !selectedSaaSTool,
    });

    const {
        data: memberOfEntity,
        isLoading: memberOfEntityLoading,
        isSuccess: memberOfEntitySuccess,
        isFetching: memberOfEntityRefetching,
    } = useMemberOfEntityQuery(
        {
            toolName: selectedSaaSTool,
            id: entityId,
        },
        {
            skip: !selectedSaaSTool || !entityId,
        }
    );

    const userChangeHandler = async (val: { value: string; label: string }) => {
        if (val?.value === payload.user?.value?.value) return;
        setPayload({
            ...payload,
            user: {
                value: val,
                isError: false,
                error: "",
            },
            saas_tools: {
                value: [
                    {
                        name: "",
                        type: "",
                        entity_name: "",
                        role: "",
                        approver: [],
                    },
                ],
                isError: false,
                error: "",
            },
        });
    };

    const nameChangeHandler = (
        val: { value: string; label: string },
        index: number
    ) => {
        const newPayload = { ...payload };
        newPayload.saas_tools.value[index].name = val;
        newPayload.saas_tools.value[index].type = manageType(val.value);
        newPayload.saas_tools.value[index].entity_name = "";
        newPayload.saas_tools.value[index].role = "";
        if (!["Box", "UR&AM Tool", "AWS"].includes(val.value)) {
            newPayload.saas_tools.value[index].entity_name = "";
            newPayload.saas_tools.value[index].approver = [];
        } else {
            delete newPayload.saas_tools.value[index].entity_name;
            const data = approverList?.result?.data.find(
                (item: any) => item.saasTool === val.value
            );

            const approvers = data?.approver.map((item: any) => ({
                value: item.id,
                label: `${item.firstName} ${item.middleName ? item.middleName + " " : ""
                    }${item.lastName}`,
            }));
            newPayload.saas_tools.value[index].approver = approvers;

            if (
                ["Modify Permission", "Remove Permission"].includes(
                    newPayload.subType.value.value
                )
            ) {
                const role = assigningEntities?.result.saas_tools.find(
                    (item: any) => item.name === val.value
                )?.role;
                newPayload.saas_tools.value[index].role = {
                    value: role,
                    label: role,
                };
            }
        }

        setPayload(newPayload);
    };

    const roleChangeHandler = (val: any, index: number) => {
        const newSaaSTools = [...payload.saas_tools.value];
        newSaaSTools[index].role = val;
        setPayload({
            ...payload,
            saas_tools: {
                value: newSaaSTools,
                isError: false,
                error: "",
            },
        });
    };

    const entitySelectHandler = (val: any, index: number) => {
        const newPayload = [...payload.saas_tools.value];
        newPayload[index].entity_name = val;
        const data = approverList?.result?.data.find(
            (item: any) =>
                item.name === val.label &&
                item.saasTool === newPayload[index].name.value
        );

        const approvers = data?.approver.map((item: any) => ({
            value: item.id,
            label: `${item.firstName} ${item.middleName ? item.middleName + " " : ""
                }${item.lastName}`,
        }));
        newPayload[index].approver = approvers;
        if (
            ["Modify Permission", "Remove Permission"].includes(
                payload.subType.value.value
            )
        ) {
            const role = assigningEntities?.result.saas_tools
                .find((item: any) => item.name === newPayload[index].name.value)
                ?.assigned.find(
                    (item: any) => item.name === newPayload[index].entity_name.label
                )?.role;
            newPayload[index].role = {
                value: role,
                label: role,
            };
        }
        setPayload({
            ...payload,
            saas_tools: {
                value: newPayload,
                isError: false,
                error: "",
            },
        });
    };

    const removeSaaSToolHandler = (index: number) => {
        const newPayload = { ...payload };
        if (newPayload.saas_tools.value.length > 1) {
            newPayload.saas_tools.value.splice(index, 1);
            setPayload(newPayload);
        }
    };

    const addSaaSToolHandler = () => {
        const newPayload = { ...payload };

        newPayload.saas_tools.value.push({
            name: "",
            type: "",
            entity_name: "",
            role: "",
            approver: [],
        });

        setPayload(newPayload);
    };
    const saasToolFocusHandler = () => {
        const assignTools = assigningEntities?.result.saas_tools.map(
            (item: any) => {
                return {
                    label: item.name,
                    value: item.name,
                };
            }
        );
        if (payload.subType.value.value === "Assign Permission") {
            const options = REQUEST_MANAGEMENT_SAAS_TOOLS.filter((tool) => {
                return assignTools?.some(
                    (assignTool: any) => assignTool.value === tool.value
                );
            });
            setSaaSToolOptions(options);
        } else {
            const options = assignTools.filter(
                (tool: DropdownOptionsType) => tool.value !== "Okta"
            );
            setSaaSToolOptions(options);
        }
    };

    const manageType = (toolName: string) => {
        if (toolName === "Confluence") return "Space";
        else if (toolName === "GitLab") return "Group";
        else if (toolName === "Miro") return "Team";
        else if (toolName === "Youtrack") return "Project";
        else if (["UR&AM Tool", "Box", "Okta", "AWS"].includes(toolName))
            return "License";
        else if (toolName === "GCP") return "Project";
        else if (toolName === "SOPHOS Cloud Optix") return "Project";
        else if (toolName === "SOPHOS MDR Agent Installation") return "OS";
        else if (toolName === "SOPHOS MDR Server Agent Installation") return "OS";
        else if (toolName === "MergeBase") return "Dashboard";
    };

    const entityFocusHandler = (
        index: number,
        saas_tool: string,
        type: string
    ) => {
        var options: DropdownOptionsType[] = [];
        if (payload.subType.value.value === "Assign Permission") {
            const filter = approverList?.result?.data?.filter(
                (item: any) => item.type === type && item.saasTool === saas_tool
            );
            const filterOptions = filter?.map((item: any) => ({
                value: item.id,
                label: item.name,
            }));
            options = filterOptions.filter(
                (val: any) =>
                    assigningEntities?.result?.assigning.find(
                        (item: any) => item.name === val.label && item.type === type
                    ) === undefined
            );
        } else {
            options = assigningEntities?.result?.saas_tools
                .find((item: any) => item.name === saas_tool)
                ?.assigned.map((item: any) => ({
                    value: item.id,
                    label: item.name,
                }));
        }
        setEntityOptions(options);
    };
    // const meHandler = () => {
    //     const newPayload = { ...payload };
    //     if (userData.email === payload?.user?.value?.value) return;
    //     newPayload.user.value = {
    //         value: userData.email,
    //         label: userData?.middleName
    //             ? `${userData.firstName} ${userData.middleName} ${userData.lastName}`
    //             : `${userData.firstName} ${userData.lastName}`,
    //     };
    //     newPayload.saas_tools.value = [
    //         {
    //             name: "",
    //             type: "",
    //             entity_name: "",
    //             role: "",
    //             approver: [],
    //         },
    //     ];
    //     setPayload(newPayload);
    // };

    const roleFocusHandler = (toolName: string) => {
        if (toolName === "UR&AM Tool") {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "Super Admin",
                        label: "Super Admin",
                    },
                    {
                        value: "Admin",
                        label: "Admin",
                    },
                    {
                        value: "Admin Viewer",
                        label: "Admin Viewer",
                    },
                    {
                        value: "User",
                        label: "User",
                    },
                ],
            });
        } else if (toolName === "Confluence") {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "Viewer",
                        label: "Viewer",
                    },
                    {
                        value: "Editor",
                        label: "Editor",
                    },
                    {
                        value: "Space Admin",
                        label: "Space Admin",
                    },
                ],
            });
        } else if (toolName === "GitLab") {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "Owner",
                        label: "Owner",
                    },
                    {
                        value: "Developer",
                        label: "Developer",
                    },
                    {
                        value: "Reporter",
                        label: "Reporter",
                    },
                ],
            });
        } else if (toolName === "Miro") {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "User",
                        label: "User",
                    },
                ],
            });
        } else if (toolName === "Youtrack") {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "Project Admin",
                        label: "Project Admin",
                    },
                    {
                        value: "Developer",
                        label: "Developer",
                    },
                ],
            });
        } else if (["Box", "AWS"].includes(toolName)) {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "User",
                        label: "User",
                    },
                ],
            });
        } else if (toolName === "GCP") {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "Owner",
                        label: "Owner",
                    },
                    {
                        value: "Editor",
                        label: "Editor",
                    },
                    {
                        value: "Viewer",
                        label: "Viewer",
                    },
                    {
                        value: "Browser",
                        label: "Browser",
                    },
                ],
            });
        } else if (toolName === "SOPHOS Cloud Optix") {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "Admin",
                        label: "Admin",
                    },
                    {
                        value: "Read Only",
                        label: "Read Only",
                    },
                    {
                        value: "HelpDesk",
                        label: "HelpDesk",
                    },
                ],
            });
        } else if (toolName === "MergeBase") {
            setRoleOptionList({
                ...roleOptionList,
                [toolName]: [
                    {
                        value: "Admin",
                        label: "Admin",
                    },
                    {
                        value: "Developer",
                        label: "Developer",
                    },
                    {
                        value: "Config",
                        label: "Config",
                    },
                ],
            });
        }
    };

    React.useEffect(() => {
        if (getUsersBySaaSToolSuccess) {
            setAssignedSaasToolUsers(saaSToolUsers?.result?.users);
            setSaasToolItems(saaSToolUsers?.result?.entities);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saaSToolUsers, getUsersBySaaSToolSuccess]);

    React.useEffect(() => {
        if (memberOfEntitySuccess) {
            setEntityMemberList(memberOfEntity?.result?.users);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [memberOfEntitySuccess, memberOfEntity]);

    const allSaaSToolClickHandler = async (saas_tool: string) => {
        setIsOpenSaaSToolModal(!isOpenSaaSToolModal);
        setSelectedSaaSTool(saas_tool);
        setSearchValue("");
        setDisplayItem("User");
    };

    const modifiers = {};

    React.useEffect(() => {
        setLoading(
            usersLoading ||
            managerLoading ||
            assigningLoading ||
            assigningFetching ||
            getUsersBySaaSToolLoading ||
            UsersBySaaSToolRefetching ||
            memberOfEntityLoading ||
            memberOfEntityRefetching
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        usersLoading,
        managerLoading,
        assigningLoading,
        assigningFetching,
        getUsersBySaaSToolLoading,
        UsersBySaaSToolRefetching,
        memberOfEntityLoading,
        memberOfEntityRefetching,
    ]);

    const saasToolSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchValue = e.target.value;
        setSearchValue(searchValue);
        var filteredData = [];
        if (displayItem === "User") {
            filteredData = saaSToolUsers?.result?.users.filter(
                (item: any) =>
                    (item.oktaUser?.email ?? "")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                    (item.oktaUser?.firstName ?? "")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                    (item.oktaUser?.middleName ?? "")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                    (item.oktaUser?.lastName ?? "")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                    [
                        item.oktaUser?.firstName,
                        item.oktaUser?.middleName,
                        item.oktaUser?.lastName,
                    ]
                        .filter(Boolean)
                        .join(" ")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase())
            );

            setAssignedSaasToolUsers(filteredData);
        } else if (["Group", "Project", "Team", "Space"].includes(displayItem)) {
            filteredData = saaSToolUsers?.result?.entities.filter((item: any) =>
                item.name.toLowerCase().includes(searchValue.toLowerCase())
            );
            setSaasToolItems(filteredData);
        } else {
            filteredData = memberOfEntity?.result?.users.filter(
                (item: any) =>
                    (item.email ?? "")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                    (item.firstName ?? "")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                    (item.lastName ?? "")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase()) ||
                    [item.firstName, item.lastName]
                        .filter(Boolean)
                        .join(" ")
                        .toLowerCase()
                        .includes(searchValue.toLowerCase())
            );
            setEntityMemberList(filteredData);
        }
    };

    return (
        <Container className={className} modifiers={modifiers}>
            <div className={`${componentClassName}__form`}>
                <div className={`${componentClassName}__form__items`}>
                    <p className={`${componentClassName}__form__title`}>
                        Available Tools with Details Information
                    </p>
                    <div className={`${componentClassName}__saasTools`}>
                        {All_SAAS_TOOLS.map((saas_tool: any, index: number) => (
                            <div
                                key={index}
                                className={`${componentClassName}__saasTools__container`}
                            >
                                <button
                                    title={saas_tool}
                                    type="button"
                                    className={`${componentClassName}__saasTools__container__button`}
                                    onClick={() => allSaaSToolClickHandler(saas_tool)}
                                >
                                    <img
                                        src={saasToolImageSrc(saas_tool)}
                                        alt={saas_tool}
                                        height={32}
                                    />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
                <div
                    className={`${componentClassName}__form__group ${payload?.user?.value?.value
                        ? `${componentClassName}__form__group--background`
                        : ""
                        }`}
                >
                    <div className={`${componentClassName}__form__items`}>
                        <label className={`${componentClassName}__form__title`}>User</label>
                        <div className={`${componentClassName}__form__user`}>
                            <Dropdown
                                className={`${componentClassName}__form__user__dropdown`}
                                options={users?.result?.data.map((user: any) => ({
                                    value: user.email,
                                    label: user?.middleName
                                        ? `${user.firstName} ${user.middleName} ${user.lastName}`
                                        : `${user.firstName} ${user.lastName}`,
                                }))}
                                selected={payload?.user?.value}
                                onClickChange={(val) =>
                                    userChangeHandler(val as { value: string; label: string })
                                }
                                isRequired
                                isClearable
                            />
                            {/* <button
                                className={`${componentClassName}__form__user__me`}
                                type="button"
                                onClick={meHandler}
                            >
                                Me
                            </button> */}
                        </div>
                    </div>

                    {/* assigned saas tools */}
                    {payload?.user?.value?.value && (
                        <div className={`${componentClassName}__form__items`}>
                            <p className={`${componentClassName}__form__title`}>
                                Assigned Tools of {payload?.user?.value?.label} with Details
                                Information
                            </p>
                            <div className={`${componentClassName}__saasTools`}>
                                {assigningEntities?.result?.saas_tools.map(
                                    (saas_tool: any, index: number) => (
                                        <div
                                            key={index}
                                            className={`${componentClassName}__saasTools__container`}
                                        >
                                            <button
                                                title={saas_tool.name}
                                                type="button"
                                                className={`${componentClassName}__saasTools__container__button`}
                                                onClick={() => {
                                                    setIsOpenEntityModal(!isOpenEntityModal);
                                                    setAssigned({
                                                        saasTool: saas_tool.name,
                                                        assignedList: saas_tool.assigned,
                                                    });
                                                }}
                                            >
                                                <img
                                                    src={saasToolImageSrc(saas_tool.name)}
                                                    alt={saas_tool.name}
                                                    height={32}
                                                />
                                            </button>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    )}
                    {payload?.user?.value?.value && (
                        <>
                            <p className={`${componentClassName}__form__title`}>
                                {payload?.subType?.value?.value === "Assign Permission"
                                    ? `Assign New Item to ${payload?.user?.value?.label}`
                                    : payload?.subType?.value?.value === "Modify Permission"
                                        ? `Modify Role of Assigned Item of ${payload?.user?.value?.label}`
                                        : `Remove Assigned Item from ${payload?.user?.value?.label}`}
                            </p>
                            {payload?.saas_tools?.value.map(
                                (saas_tool: any, index: number) => {
                                    return (
                                        <div
                                            key={index}
                                            className={`${componentClassName}__form__items`}
                                        >
                                            <div className={`${componentClassName}__form__item`}>
                                                <div className={`${componentClassName}__form__item__group`}>
                                                    <label className={`${componentClassName}__form__item__label`}>
                                                        SaaS Tool
                                                    </label>
                                                    <Dropdown
                                                        className={`${componentClassName}__form__item__dropdown`}
                                                        options={saasToolOptions}
                                                        selected={
                                                            saas_tool?.name?.value === ""
                                                                ? null
                                                                : saas_tool?.name
                                                        }
                                                        placeholder="Select saas tool"
                                                        onClickChange={(val) =>
                                                            nameChangeHandler(
                                                                val as { value: string; label: string },
                                                                index
                                                            )
                                                        }
                                                        focusHandler={saasToolFocusHandler}
                                                        isRequired
                                                    />
                                                </div>
                                                {saas_tool?.type !== "License" && (
                                                    <div className={`${componentClassName}__form__item__group`}>
                                                        <label className={`${componentClassName}__form__item__label`}>
                                                            {manageType(saas_tool?.name.value)} Name
                                                        </label>
                                                        <Dropdown
                                                            className={`${componentClassName}__form__item__dropdown`}
                                                            options={entityOptions}
                                                            selected={
                                                                saas_tool?.entity_name?.value === ""
                                                                    ? null
                                                                    : saas_tool?.entity_name
                                                            }
                                                            placeholder={
                                                                manageType(saas_tool?.name.value)
                                                                    ? `Select ${manageType(
                                                                        saas_tool?.name.value
                                                                    )?.toLocaleLowerCase()} name`
                                                                    : "Select name"
                                                            }
                                                            onClickChange={(val) =>
                                                                entitySelectHandler(
                                                                    val as { value: string; label: string },
                                                                    index
                                                                )
                                                            }
                                                            focusHandler={() =>
                                                                entityFocusHandler(
                                                                    index,
                                                                    saas_tool.name.value,
                                                                    saas_tool.type
                                                                )
                                                            }
                                                            isRequired
                                                        />
                                                    </div>
                                                )}
                                                {!([
                                                    "SOPHOS MDR Agent Installation",
                                                    "SOPHOS MDR Server Agent Installation",
                                                ].includes(saas_tool?.name?.value)) && (
                                                        <div className={`${componentClassName}__form__item__group`}>
                                                            <label className={`${componentClassName}__form__item__label`}>
                                                                Role
                                                            </label>
                                                            <Dropdown
                                                                className={`${componentClassName}__form__item__dropdown`}
                                                                options={roleOptionList[saas_tool.name.value]}
                                                                selected={
                                                                    saas_tool?.role?.value === ""
                                                                        ? null
                                                                        : saas_tool?.role
                                                                }
                                                                placeholder="Select role"
                                                                onClickChange={(val) => roleChangeHandler(val, index)}
                                                                focusHandler={() =>
                                                                    roleFocusHandler(saas_tool.name.value)
                                                                }
                                                                isRequired
                                                                isDisabled={["Remove Permission"].includes(
                                                                    payload.subType.value.value
                                                                )}
                                                            />
                                                        </div>
                                                    )}
                                                <div className={`${componentClassName}__form__item__group`}>
                                                    <label className={`${componentClassName}__form__item__label`}>
                                                        Approvers
                                                    </label>
                                                    <Dropdown
                                                        className={`${componentClassName}__form__item__dropdown`}
                                                        options={
                                                            managerList?.result?.data?.map((user: any) => ({
                                                                label: user?.middleName
                                                                    ? `${user?.firstName} ${user?.middleName} ${user?.lastName}`
                                                                    : `${user?.firstName} ${user?.lastName}`,
                                                                value: user.id,
                                                            })) ?? []
                                                        }
                                                        onClickChange={() => { }}
                                                        placeholder="Approvers"
                                                        isIcon
                                                        color="black"
                                                        selected={saas_tool?.approver}
                                                        isMulti
                                                        isDisabled
                                                    />
                                                </div>
                                            </div>
                                            {payload?.saas_tools?.value.length > 1 && (
                                                <div
                                                    className={`${componentClassName}__form__items__remove`}
                                                >
                                                    <button
                                                        onClick={() => removeSaaSToolHandler(index)}
                                                        type="button"
                                                        className={`${componentClassName}__form__items__remove__button`}
                                                    >
                                                        <Icon icon="delete" size="primary" />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    );
                                }
                            )}
                        </>
                    )}
                </div>
                {payload?.saas_tools?.value[payload?.saas_tools?.value.length - 1]?.name
                    ?.value &&
                    payload?.saas_tools?.value[payload?.saas_tools?.value.length - 1]
                        ?.role?.value &&
                    (payload?.saas_tools?.value[payload?.saas_tools?.value.length - 1]
                        ?.entity_name?.value ||
                        !payload?.saas_tools?.value[
                            payload?.saas_tools?.value.length - 1
                        ]?.hasOwnProperty("entity_name")) && (
                        <button
                            type="button"
                            onClick={() => addSaaSToolHandler()}
                            className={`${componentClassName}__form__add`}
                        >
                            Add Tool
                        </button>
                    )}
            </div>

            <Modal
                header={`Assigned Item of ${assigned.saasTool}`}
                isOpen={isOpenEntityModal}
                onClose={() => setIsOpenEntityModal(false)}
                width="large"
            >
                <div className={`${componentClassName}__modalContainer`}>
                    {assigned.assignedList.length > 0 ? (
                        assigned.assignedList.map((entity: any, index: number) => {
                            return (
                                <div key={index} className={`${componentClassName}__modal`}>
                                    <Dropdown
                                        className={`${componentClassName}__modal__dropdown`}
                                        options={[]}
                                        selected={{
                                            label: entity?.saasTool + " " + entity?.type,
                                            value: entity?.saasTool,
                                        }}
                                        onClickChange={() => { }}
                                        isDisabled
                                    />
                                    <Dropdown
                                        className={`${componentClassName}__modal__dropdown`}
                                        options={[]}
                                        selected={{
                                            label: entity?.name,
                                            value: entity?.name,
                                        }}
                                        onClickChange={() => { }}
                                        isDisabled
                                        title={entity?.name}
                                    />
                                    <Dropdown
                                        className={`${componentClassName}__modal__dropdown`}
                                        options={[]}
                                        selected={{
                                            label: entity?.role,
                                            value: entity?.role,
                                        }}
                                        onClickChange={() => { }}
                                        isDisabled
                                    />
                                    <Dropdown
                                        className={`${componentClassName}__modal__approvers`}
                                        options={[]}
                                        selected={entity?.approver.map((approver: any) => ({
                                            label: approver?.middleName
                                                ? `${approver?.firstName} ${approver?.middleName} ${approver?.lastName}`
                                                : `${approver?.firstName} ${approver?.lastName}`,
                                            value: approver?.id,
                                        }))}
                                        onClickChange={() => { }}
                                        isMulti
                                        isDisabled
                                    />
                                </div>
                            );
                        })
                    ) : (
                        <div className={`${componentClassName}__modal__empty`}>
                            <p>There is no assigned item for {assigned.saasTool}</p>
                        </div>
                    )}
                </div>
            </Modal>

            <Modal
                header={`Assigned Item of ${selectedSaaSTool}`}
                isOpen={isOpenSaaSToolModal}
                onClose={() => setIsOpenSaaSToolModal(false)}
                width="large"
            >
                <div className={`${componentClassName}__modalContainer`}>
                    <div className={`${componentClassName}__modal__users`}>
                        <div className={`${componentClassName}__modal__users__header`}>
                            <div className={`${componentClassName}__modal__users__search`}>
                                <Input
                                    value={searchValue}
                                    type="text"
                                    placeholder="Search"
                                    onChange={saasToolSearchHandler}
                                />
                            </div>
                            <div
                                className={`${componentClassName}__modal__users__buttonGroup`}
                            >
                                <button
                                    type="button"
                                    className={`${componentClassName}__modal__users__button ${componentClassName}__modal__users__button--left ${displayItem === "User"
                                        ? `${componentClassName}__modal__users__button--active`
                                        : ""
                                        }`}
                                    onClick={() => {
                                        setDisplayItem("User");
                                        setSearchValue("");
                                        setSaasToolItems(saaSToolUsers?.result?.entities);
                                    }}
                                >
                                    User
                                </button>
                                {![
                                    "UR&AM Tool",
                                    "Okta",
                                    "Box",
                                    "AWS",
                                    "SOPHOS MDR",
                                    "SOPHOS MDR Server",
                                    "SOPHOS ZTNA",
                                ].includes(selectedSaaSTool) && (
                                        <button
                                            type="button"
                                            className={`${componentClassName}__modal__users__button ${componentClassName}__modal__users__button--right ${["Group", "Project", "Team", "Space", "Member"].includes(
                                                displayItem
                                            )
                                                ? `${componentClassName}__modal__users__button--active`
                                                : ""
                                                }`}
                                            onClick={() => {
                                                setDisplayItem("Group");
                                                setSearchValue("");
                                                setAssignedSaasToolUsers(saaSToolUsers?.result?.users);
                                                setSaasToolItems(saaSToolUsers?.result?.entities);
                                            }}
                                        >
                                            {["Youtrack", "GCP", "SOPHOS Cloud Optix"].includes(
                                                selectedSaaSTool
                                            )
                                                ? "Project"
                                                : selectedSaaSTool === "Miro"
                                                    ? "Team"
                                                    : selectedSaaSTool === "Confluence"
                                                        ? "Space"
                                                        : selectedSaaSTool === "MergeBase"
                                                            ? "Dashboard" : "Group"}
                                        </button>
                                    )}
                            </div>
                        </div>
                        {displayItem === "User" ? (
                            assignedSaasToolUsers?.length > 0 ? (
                                assignedSaasToolUsers.map((user: any, index: number) => (
                                    <div
                                        key={index}
                                        className={`${componentClassName}__modal__user`}
                                    >
                                        <div
                                            className={`${componentClassName}__modal__user__container`}
                                        >
                                            <p className={`${componentClassName}__modal__user__name`}>
                                                {[
                                                    user?.oktaUser?.firstName,
                                                    user?.oktaUser?.middleName,
                                                    user?.oktaUser?.lastName,
                                                ]
                                                    .filter(Boolean)
                                                    .join(" ")}
                                            </p>
                                            <p
                                                className={`${componentClassName}__modal__user__email`}
                                            >
                                                {user?.email}
                                            </p>
                                        </div>
                                        <p className={`${componentClassName}__modal__user__role`}>
                                            {user?.role}
                                        </p>
                                    </div>
                                ))
                            ) : (
                                <div className={`${componentClassName}__modal__empty`}>
                                    <p>Nothing Found</p>
                                </div>
                            )
                        ) : ["Group", "Project", "Team", "Space"].includes(displayItem) ? (
                            saasToolItems?.length > 0 ? (
                                saasToolItems.map((item: any, index: number) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`${componentClassName}__modal__user ${componentClassName}__modal__user--group`}
                                        onClick={() => {
                                            setDisplayItem("Member");
                                            setEntityId(item.id);
                                            setSearchValue("");
                                        }}
                                    >
                                        <div
                                            className={`${componentClassName}__modal__user__container`}
                                        >
                                            <p className={`${componentClassName}__modal__user__name`}>
                                                {item?.name}
                                            </p>
                                        </div>
                                    </button>
                                ))
                            ) : (
                                <div className={`${componentClassName}__modal__empty`}>
                                    <p>Nothing Found</p>
                                </div>
                            )
                        ) : entityMemberList?.length > 0 ? (
                            entityMemberList.map((user: any, index: number) => (
                                <div
                                    key={index}
                                    className={`${componentClassName}__modal__user`}
                                >
                                    <div
                                        className={`${componentClassName}__modal__user__container`}
                                    >
                                        <p className={`${componentClassName}__modal__user__name`}>
                                            {[user?.firstName, user?.lastName]
                                                .filter(Boolean)
                                                .join(" ")}
                                        </p>
                                        <p className={`${componentClassName}__modal__user__email`}>
                                            {user?.email}
                                        </p>
                                    </div>
                                    <p className={`${componentClassName}__modal__user__role`}>
                                        {user?.role}
                                    </p>
                                </div>
                            ))
                        ) : (
                            <div className={`${componentClassName}__modal__empty`}>
                                <p>Nothing Found</p>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        </Container>
    );
};
